/**
 * Maps a requested `currency` field's `currencyCode` to its display symbol. Shared by the recipient
 * input (`currency-field-input.js`) and the reviewer's read-only value (`currency-field-value.js`) so
 * both surfaces show the same symbol. The vocabulary mirrors `currency-code-editor.js` (GBP/USD/EUR);
 * the server defaults a missing code to "GBP", so anything unrecognised falls back to the pound sign.
 *
 * @param {string} [currencyCode]
 * @returns {string} the currency symbol (£/$/€)
 */
export function getCurrencySymbol(currencyCode) {
    if (currencyCode === "USD") return "$"
    if (currencyCode === "EUR") return "€"
    return "£"
}
